import "./AppsGalleryIcon.css";
import newTabIcon from "url:../../../assets/newtab.svg";

export function AppsGalleryIcon({
    icon,
    name,
    command,
    hasNewTabIcon,
    onClick,
}) {
    const handleClick = (e) => {
        //e.stopPropagation();
        onClick(command);
    };

    return (
        <div className={`apps-gallery-icon`} onClick={handleClick}>
            <img src={icon} alt={name} className="apps-gallery-icon_image" />

            <span className="apps-gallery-icon_name">
                {name}
                {hasNewTabIcon && (
                    <img
                        src={newTabIcon}
                        alt=""
                        className="apps-gallery-icon-new_tab_icon"
                    />
                )}
            </span>
        </div>
    );
}
